// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function decodeRouteParams(params: unknown): any {
    if (!params || typeof params !== "object") {
        return params;
    }
    return Object.fromEntries(Object.entries(params).map(([key, value]) => [key, decodeURIComponent(value)]));
}
